// Signing links are keys (Nic 2026-10-24): anyone holding /sign/<token> can
// open and sign that packet, so the token never goes to Sentry. Every string
// in an event, transaction or breadcrumb has it swapped for [token].
const SIGN_TOKEN = /(\/sign\/)[A-Za-z0-9_-]{16,}/g;
export const scrubSignTokens = (value, depth = 0) => {
  if (typeof value === 'string') return value.replace(SIGN_TOKEN, '$1[token]');
  if (!value || typeof value !== 'object' || depth > 8) return value;
  if (Array.isArray(value)) return value.map((v) => scrubSignTokens(v, depth + 1));
  Object.keys(value).forEach((k) => {
    value[k] = scrubSignTokens(value[k], depth + 1);
  });
  return value;
};
